import React, { useEffect, useState } from 'react';
import { Card, Row, Col } from 'antd';
import SupplierForm from '../components/Supplier/SupplierForm';
import SupplierList from '../components/Supplier/SupplierList';
import { Supplier } from '../types/supplier';
import { useTranslation } from "react-i18next";
import { useSupplier } from '../store/supplierContext';
import { CurrencyProvider } from '../store/currencyContext';

const SuppliersPage: React.FC = () => {
    const [editSupplier, setEditSupplier] = useState<Supplier | undefined>(undefined);
    const { fetchSuppliers } = useSupplier();
    const { t, i18n } = useTranslation();

    useEffect(() => {
        fetchSuppliers();
    }, []);

    return (
        <CurrencyProvider>
            <div style={{ padding: 16, direction: i18n.language === 'ar' || i18n.language === 'ckb' ? 'rtl' : 'ltr' }}>
                <Row gutter={[16, 16]}>
                    <Col xs={24} md={10} lg={8}>
                        <Card title={editSupplier ? t('edit_supplier') : t('add_supplier')}>
                            <SupplierForm
                                editSupplier={editSupplier}
                                onFinishEdit={() => setEditSupplier(undefined)}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={14} lg={16}>
                        <Card title={t('supplier_list')}>
                            <SupplierList onEdit={setEditSupplier} />
                        </Card>
                    </Col>
                </Row>
            </div>
        </CurrencyProvider>
    );
};

export default SuppliersPage;
